import { useMemo } from 'react';
import {
  useGetEvaluationsForLecturer,
  getGetEvaluationsForLecturerQueryKey,
} from '../../api/endpoints/evaluations/evaluations';

/**
 * Hook to fetch and manage pending submissions for a lecturer.
 * Uses the new unified evaluations endpoint with state filtering.
 *
 * @param moduleId - Optional module ID to filter submissions
 */
export const usePendingSubmissions = (moduleId?: string) => {
  // Fetch only submitted evaluations (pending grading)
  const params = useMemo(() => ({
    moduleId: moduleId || undefined,
    filter: 'state:submitted',
    sort: 'submittedAt', // Most recent first
  }), [moduleId]);

  const {
    data: response,
    isLoading,
    isError,
    error,
  } = useGetEvaluationsForLecturer(params, {
    query: {
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  });

  // Extract the actual list of evaluations from the API response
  const data = response?.data?.data || [];

  return {
    data,
    isLoading,
    isError,
    error,
    // Provide the query key for manual invalidation if needed
    queryKey: getGetEvaluationsForLecturerQueryKey(params),
  };
};

export default usePendingSubmissions;
